<template>
  <v-container class="pa-4 pt-1" fluid>
    <v-card class="pl-6 pr-6 pt-6 pb-6">
      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">Contact Information</v-card-title>
        </v-col>
        <v-col align="right" color="primary" cols="12" md="6"></v-col>
      </v-row>

      <!-- Search and Filter Section -->
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field class="heightsizesearch" v-model="search_ct" outlined dense label="Search"
            v-on:keyup.enter="onSearchPagination()"></v-text-field>
          <h4 class="text-danger red--text">
            * input text and enter for search
          </h4>
        </v-col>

        <v-col cols="12" md="2" class="d-flex mb-6">
          <v-select v-model="s_contact_type" clearable @click:clear="
            $nextTick(() => {
              s_contact_type = 0;
            })
            " label="Contact Type" :items="contact_type" item-text="contact_typename" item-value="contact_typenumber"
            outlined dense required style="width: 150px" @change="onSearchPagination"></v-select>
        </v-col>

        <v-col cols="12" md="6" class="d-flex justify-end mb-6">
          <v-btn @click="openadd" color="#0A7EA5" rounded dark class="mb-2" :disabled="!authorize_add">
            <span>Add</span>
            <v-icon small center>add</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <br />

      <!-- Data Table Section -->
      <!-- <v-card outlined tile>
        <v-data-table
          @page-count="pageCount = $event"
          :search="search"
          :headers="headers"
          :items="mDataArray"
          class="elevation-1"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
        >
          <template v-slot:[`item.poa`]="{ item }">
            <v-btn small @click="openPOA(item)" v-if="authorize_edit">
              POA
            </v-btn>
          </template>

<template v-slot:[`item.actions`]="{ item }">
            <v-icon
              :style="{
                backgroundColor: '#E1F5FE',
                color: '#254E58',
              }"
              @click="openeditItem(item)"
              v-if="authorize_edit"
            >
              mdi-pencil
            </v-icon>

            <v-icon
              class="ml-3"
              :style="{
                backgroundColor: '#FFEBEE',
                color: '#9E3B1B',
              }"
              @click="deleteItem(item.contact_id)"
              v-if="authorize_del"
            >
              mdi-delete
            </v-icon>
          </template>
</v-data-table>

<v-progress-linear indeterminate color="teal" v-if="load_bg"></v-progress-linear>
</v-card> -->

      <!-- Pagination Section -->
      <div>
        <v-select v-model="itemsPerPage" @change="onSearchPagination" style="width: 150px" :items="item_per_page_list"
          label="Items per page" dense outlined hide-details></v-select>
      </div>
      <div>
        <div class="text-center pt-2">
          <v-pagination class="ma-3" v-model="page" :length="pageCount" @input="loadDataByPage"
            total-visible="19"></v-pagination>
        </div>

        <v-data-table :headers="headers" :items="mDataArray2" :server-items-length="totalItems" :options.sync="options"
          @update:options="onOptionsUpdate" hide-default-footer class="elevation-1">
          <template v-slot:[`item.poa`]="{ item }">
            <v-btn small @click="openPOA(item)" v-if="authorize_edit">
              POA
            </v-btn>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-icon :style="{
              backgroundColor: '#E1F5FE',
              color: '#254E58',
            }" @click="openeditItem(item)" v-if="authorize_edit">
              mdi-pencil
            </v-icon>

            <v-icon class="ml-3" :style="{
              backgroundColor: '#FFEBEE',
              color: '#9E3B1B',
            }" @click="deleteItem(item.contact_id)" v-if="authorize_del">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </div>

      <!-- Add/Edit Dialog -->
      <v-dialog v-model="dialogAddData" max-width="700px">
        <v-card>
          <br />
          <v-card-title class="text-h6">
            Contact & Address Information
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6" style="padding-right: 40px">
                  <v-row style="flex-direction: column">
                    <h3><span class="vali">*</span>Contact Type</h3>
                    <v-select v-model="itemdata.contact_type" :items="contact_type" item-text="contact_typename"
                      item-value="contact_typenumber" outlined dense required></v-select>
                  </v-row>

                  <v-row style="flex-direction: column; margin-top: -10px">
                    <h3><span class="vali">*</span>Contact Name</h3>
                    <v-text-field v-model="itemdata.contact_name" outlined dense required></v-text-field>
                  </v-row>

                  <v-row style="flex-direction: column; margin-top: -10px">
                    <h3>Mapping Client</h3>
                    <v-autocomplete clearable @click:clear="
                      $nextTick(() => {
                        itemdata.customer_name = 0;
                      })
                      " v-model="itemdata.mapping_cust_id" :items="customer_name_list" item-text="name" item-value="id"
                      outlined @change="
                        onSelectMappingCustomerChange(itemdata.mapping_cust_id)
                        " dense></v-autocomplete>
                  </v-row>
                </v-col>

                <v-col cols="12" sm="6" md="6" style="padding-left: 40px">
                  <v-row style="flex-direction: column">
                    <h3>Contact Person (ชื่อคนติดต่อ)</h3>
                    <v-text-field v-model="itemdata.contact_person" outlined dense></v-text-field>
                  </v-row>

                  <v-row style="flex-direction: column; margin-top: -10px">
                    <h3>
                      <span class="vali" v-if="itemdata.contact_type == 2">*</span>
                      Contact Email
                    </h3>
                    <v-text-field v-model="itemdata.email" outlined dense></v-text-field>
                  </v-row>

                  <v-row style="flex-direction: column; margin-top: -10px">
                    <h3>Telephone</h3>
                    <v-text-field v-model="itemdata.telephone" outlined dense></v-text-field>
                  </v-row>
                </v-col>
              </v-row>

              <v-row style="margin-top: -10px">
                <v-col cols="12" sm="12" md="12">
                  <v-row style="flex-direction: column">
                    <h3><span class="vali">*</span>Full Address</h3>
                    <v-textarea v-model="itemdata.address" multi-line outlined dense rows="5"></v-textarea>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed width="100" class="mr-3 buttonblue" @click="saveaddItem()">
              Save
            </v-btn>
            <v-btn depressed outlined width="100" @click="closeaddItem()">
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
          <br />
        </v-card>
      </v-dialog>

      <!-- Delete Confirmation Dialog -->
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">
            Are you sure you want to delete this item?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">
              Cancel
            </v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">
              OK
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <!-- Success Dialogs -->
    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
    <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
  </v-container>
</template>

<script>
import api from "@/services/api";
import { server } from "@/services/constants";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import SuccessDialog from "@/components/cards/SuccessDialog";

export default {
  name: "MasterTradeMark",
  components: { SuccessDialog, SuccessDialogPush },

  data() {
    return {
      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 200,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      // Authorization
      userId: 0,
      authorize: [],
      authorize_view: false,
      authorize_add: false,
      authorize_edit: false,
      authorize_del: false,
      authorize_id: 0,

      // UI States
      load_bg: false,
      dialogAdd: false,
      dialogAddData: false,
      dialogDelete: false,
      isShowPassword: false,
      fullPage: true,

      // Search and Filter
      search: "",
      search_ct: "",
      s_contact_type: 0,

      // Data
      dataAll: [],
      mDataArray: [],

      // Contact Types
      contact_type: [
        { contact_typenumber: 1, contact_typename: "Client" },
        { contact_typenumber: 2, contact_typename: "Agent" },
        { contact_typenumber: 3, contact_typename: "Associate" },
      ],

      // Form Data
      itemdata: {
        contact_type: 0,
        mapping_cust_id: 0,
        contact_name: "",
        contact_person: "",
        position: "",
        email: "",
        address: "",
        city: "",
        country: "",
        telephone: "",
        fax: "",
        status: "A",
      },
      edititemdata: {
        contact_type: 0,
        mapping_cust_id: 0,
        contact_name: "",
        contact_person: "",
        position: "",
        email: "",
        address: "",
        city: "",
        country: "",
        telephone: "",
        fax: "",
      },

      // Dialog States
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      contactid_del: 0,
      oparation: "",

      // Table Headers
      headers: [
        {
          text: "Contact Type",
          value: "contact_typeShow",
          class: "bg-colorth",
          divider: true,
          width: "8%",
        },
        {
          text: "Contact Name",
          value: "contact_name",
          class: "bg-colorth",
          divider: true,
          width: "10%",
        },
        {
          text: "Contact Person",
          value: "contact_person",
          class: "bg-colorth",
          divider: true,
          width: "13%",
        },
        {
          text: "Address",
          value: "address",
          class: "bg-colorth",
          divider: true,
          width: "13%",
        },
        {
          text: "Telephone",
          value: "telephone",
          class: "bg-colorth",
          divider: true,
        },
        {
          text: "Email",
          value: "email",
          class: "bg-colorth",
          divider: true,
        },
        {
          text: "POA",
          value: "poa",
          class: "bg-colorth",
          divider: true,
          align: "center",
          sortable: false,
        },
        {
          text: "",
          value: "actions",
          class: "bg-colorth",
          divider: true,
          width: "95px",
          sortable: false,
        },
      ],

      customer_name_list: [],
    };
  },

  async mounted() {
    this.$showLoader();
    await api.checkVersion();

    // Check Authorization
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    if (this.authorize_id == null || this.authorize_id == 0) {
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");
    const res_auth = await api.getAuthorize(this.userId, router_path);

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // Load Data
    // await this.loaddataLimit200();
    await this.loaddataPagination();
    await this.loadCustomer();
    this.$hideLoader();
  },

  beforeCreate() {
    this.$store.state.navMenu = true;
  },

  methods: {
    async onOptionsUpdate(options) {
      console.log("Options updated:", JSON.stringify(options));

      this.$showLoader();
      let tmp = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "DESC";
      } else {
        sortDesc = "ASC";
      }

      console.log(`sortDesc:`, sortDesc);

      const result = await api.getAllContactPaginationBySort(
        options.page,
        this.itemsPerPage,
        this.search_ct.trim(),
        this.s_contact_type,
        options.sortBy[0],
        sortDesc
      );
      // console.log(`result.data:`, JSON.stringify(result.data));

      tmp = result.data.data;
      tmp.forEach((item) => {
        if (item.contact_type == 1) {
          item.contact_typeShow = "Client";
        } else if (item.contact_type == 2) {
          item.contact_typeShow = "Agent";
        } else {
          item.contact_typeShow = "Associate";
        }
      });

      this.dataAll2 = tmp;
      this.mDataArray2 = tmp;
      this.totalItems = result.data.pagination.totalItems;
      this.page = result.data.pagination.currentPage;
      this.pageCount = result.data.pagination.totalPages;
      this.$hideLoader();
    },
    async loadDataByPage(pageNumber) {
      this.$showLoader();
      let tmp = [];
      console.log(`pageNumber:`, pageNumber);
      console.log(`itemsPerPage:`, this.itemsPerPage);

      const result = await api.getAllContactPagination(
        pageNumber,
        this.itemsPerPage
      );
      // console.log(`result.data:`, JSON.stringify(result.data));

      tmp = result.data.data;
      tmp.forEach((item) => {
        if (item.contact_type == 1) {
          item.contact_typeShow = "Client";
        } else if (item.contact_type == 2) {
          item.contact_typeShow = "Agent";
        } else {
          item.contact_typeShow = "Associate";
        }
      });

      this.dataAll2 = tmp;
      this.mDataArray2 = tmp;
      this.totalItems = result.data.pagination.totalItems;
      this.page = result.data.pagination.currentPage;
      this.pageCount = result.data.pagination.totalPages;
      this.$hideLoader();
    },

    async loaddataPagination() {
      var tmp = [];
      const result = await api.getAllContactPagination(
        this.page,
        this.itemsPerPage
      );

      tmp = result.data.data;
      tmp.forEach((item) => {
        if (item.contact_type == 1) {
          item.contact_typeShow = "Client";
        } else if (item.contact_type == 2) {
          item.contact_typeShow = "Agent";
        } else {
          item.contact_typeShow = "Associate";
        }
      });

      this.dataAll2 = tmp;
      this.mDataArray2 = tmp;
      this.totalItems = result.data.pagination.totalItems;
      this.page = result.data.pagination.currentPage;
      this.itemsPerPage = result.data.pagination.itemsPerPage;
      this.pageCount = result.data.pagination.totalPages;
    },

    async onSelectMappingCustomerChange(id) {
      this.customer_name_list.filter((item) => {
        if (item.id == id) {
          this.itemdata.contact_name = item.name;
          this.itemdata.contact_person = item.contact_name;
          this.itemdata.address = item.address;
          this.itemdata.city = item.provice;
          this.itemdata.country = item.country;
          return;
        }
      });
    },

    async loadCustomer() {
      const result = await api.getAllCustomerListactiveCompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });
      this.customer_name_list = result.data;
    },

    async loaddataLimit200() {
      var tmp = [];
      const result = await api.getAllContactLimit200();
      tmp = result.data;
      tmp.forEach((item) => {
        if (item.contact_type == 1) {
          item.contact_typeShow = "Client";
        } else if (item.contact_type == 2) {
          item.contact_typeShow = "Agent";
        } else {
          item.contact_typeShow = "Associate";
        }
      });
      this.dataAll = tmp;
      this.mDataArray = tmp;
    },

    async loaddata() {
      this.load_bg = true;
      var tmp = [];
      const result = await api.getAllContact();
      tmp = result.data;
      tmp.forEach((item) => {
        if (item.contact_type == 1) {
          item.contact_typeShow = "Client";
        } else if (item.contact_type == 2) {
          item.contact_typeShow = "Agent";
        } else {
          item.contact_typeShow = "Associate";
        }
      });

      this.dataAll = this.mDataArray.concat(tmp);
      this.mDataArray = this.mDataArray.concat(tmp);
      this.load_bg = false;
    },

    async openadd() {
      this.itemdata = {
        contact_type: 0,
        mapping_cust_id: 0,
        contact_name: "",
        contact_person: "",
        position: "",
        email: "",
        address: "",
        city: "",
        country: "",
        telephone: "",
        fax: "",
        status: "A",
      };
      this.dialogAddData = true;
      this.oparation = "create";
    },

    async closeaddItem() {
      this.dialogAddData = false;
      this.itemdata = {
        contact_type: 0,
        mapping_cust_id: 0,
        contact_name: "",
        contact_person: "",
        position: "",
        email: "",
        address: "",
        city: "",
        country: "",
        telephone: "",
        fax: "",
        status: "A",
      };
      this.oparation = "";
    },

    openPOA(item) {
      window.open("/poa/" + item.contact_id);
    },

    openeditItem(item) {
      this.oparation = "update";
      this.itemdata.contact_type = Number(item.contact_type);
      this.itemdata.mapping_cust_id = item.mapping_cust_id;
      this.itemdata.contact_name = item.contact_name;
      this.itemdata.contact_person = item.contact_person;
      this.itemdata.position = item.position;
      this.itemdata.email = item.email;
      this.itemdata.address = item.address;
      this.itemdata.city = item.city;
      this.itemdata.country = item.country;
      this.itemdata.telephone = item.telephone;
      this.itemdata.fax = item.fax;
      this.dialogAddData = true;
      this.contactid_del = item.contact_id;
    },

    deleteItem(item) {
      this.dialogDelete = true;
      this.contactid_del = item;
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    async deleteItemConfirm() {
      this.$showLoader();
      const update_contact = await api.updateContact(this.contactid_del, {
        status: "D",
      });

      if (update_contact.status == 200 || update_contact.status == 201) {
        this.onSearchPagination();
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "ลบข้อมูล",
          "ลบข้อมูลสำเร็จ",
          "text-h5 green--text text-center",
          "/contact-list"
        );
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ลบข้อมูล",
          "ไม่สามารถลบได้",
          "text-h5 red--text text-center"
        );
      }

      this.dialogDelete = false;
      await this.loaddataLimit200();
      this.$hideLoader();
    },

    async saveaddItem() {
      // Validation
      if (!this.itemdata.contact_type) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Select Contact Type",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (!this.itemdata.contact_name) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Select Contact Name",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (!this.itemdata.address) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Select Full Address",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (this.itemdata.contact_type == 2 && this.itemdata.email == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Select Email",
          "text-h5 red--text text-center"
        );
        return;
      }

      this.$showLoader();

      if (this.oparation == "create") {
        const create_contact = await api.createContact(this.itemdata);

        if (create_contact.status == 200 || create_contact.status == 201) {
          this.onSearchPagination();
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "บันทึกข้อมูล",
            "บันทึกข้อมูลสำเร็จ",
            "text-h5 green--text text-center",
            "/contact-list"
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "บันทึกข้อมูล",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
        }
      } else {
        this.edititemdata.contact_type = this.itemdata.contact_type;
        this.edititemdata.mapping_cust_id = this.itemdata.mapping_cust_id;
        this.edititemdata.contact_name = this.itemdata.contact_name;
        this.edititemdata.contact_person = this.itemdata.contact_person;
        this.edititemdata.position = this.itemdata.position;
        this.edititemdata.email = this.itemdata.email;
        this.edititemdata.address = this.itemdata.address;
        this.edititemdata.city = this.itemdata.city;
        this.edititemdata.country = this.itemdata.country;
        this.edititemdata.telephone = this.itemdata.telephone;
        this.edititemdata.fax = this.itemdata.fax;

        const update_contact = await api.updateContact(
          this.contactid_del,
          this.edititemdata
        );

        if (update_contact.status == 200 || update_contact.status == 201) {
          this.onSearchPagination();
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "บันทึกข้อมูล",
            "บันทึกข้อมูลสำเร็จ",
            "text-h5 green--text text-center",
            "/contact-list"
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "บันทึกข้อมูล",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
        }
      }

      this.closeaddItem();
      this.$hideLoader();
    },

    async onSearch() {
      if (!this.s_contact_type && this.search_ct == "") {
        await this.loaddataLimit200();
      } else {
        this.mDataArray = [];
        var s_data = {
          search_ct: this.search_ct.trim(),
          contact_type: this.s_contact_type,
        };

        const result = await api.getMasterContactSearch({
          params: s_data,
        });

        this.mDataArray = result.data;
      }
    },

    async onSearchPagination() {
      if (!this.s_contact_type && this.search_ct == "") {
        await this.loaddataPagination();
      } else {
        this.mDataArray2 = [];
        let tmp = [];
        this.page = 1;
        this.$showLoader();
        var s_data = {
          page: 1,
          limit: this.itemsPerPage,
          search_ct: this.search_ct.trim(),
          contact_type: this.s_contact_type,
        };

        const result = await api.getAllContactPaginationByQuery(
          s_data.page,
          s_data.limit,
          s_data.search_ct,
          s_data.contact_type
        );

        tmp = result.data.data;
        tmp.forEach((item) => {
          if (item.contact_type == 1) {
            item.contact_typeShow = "Client";
          } else if (item.contact_type == 2) {
            item.contact_typeShow = "Agent";
          } else {
            item.contact_typeShow = "Associate";
          }
        });

        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;
        this.totalItems = result.data.pagination.totalItems;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.itemsPerPage;
        this.pageCount = result.data.pagination.totalPages;
        this.$hideLoader();
      }
    },

    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },

    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
};
</script>

<style scoped>
.widthbtnimagefile {
  width: 40%;
}

.widthsizesearch {
  width: 70%;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

.heightsize70formadvance {
  height: 80px;
}

.vali {
  color: red;
}

h3 {
  font-size: 1.17em;
}

.heightsizesearch {
  height: 45%;
}
</style>
